import { render, staticRenderFns } from "./emarticonQuestionsWeb.vue?vue&type=template&id=790ac008&scoped=true"
import script from "./emarticonQuestionsWeb.vue?vue&type=script&lang=js"
export * from "./emarticonQuestionsWeb.vue?vue&type=script&lang=js"
import style0 from "./emarticonQuestionsWeb.vue?vue&type=style&index=0&id=790ac008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790ac008",
  null
  
)

export default component.exports